module.exports = __webpack_public_path__ + "img/marker_bed.f9556703.png";